var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 25,
    viewBox: "0 0 40 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3847 0H2.61528C1.1709 0 0 1.16259 0 2.59671V22.4033C0 23.8374 1.1709 25 2.61528 25H37.3847C38.8291 25 40 23.8374 40 22.4033V2.59671C40 1.16259 38.8291 0 37.3847 0Z",
    fill: "#1A1F71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0876 8.53258L17.3734 16.4902H15.2989L17.013 8.53258H19.0876ZM27.8116 13.6727L28.9045 10.6838L29.5334 13.6727H27.8154H27.8116ZM30.1277 16.494H32.0451L30.3693 8.53638H28.6015C28.2027 8.53638 27.8653 8.76483 27.7195 9.11893L24.6096 16.494H26.7877L27.221 15.3061H29.8823L30.1354 16.494H30.1277ZM24.7131 13.8973C24.7208 11.7956 21.7872 11.6814 21.8102 10.7409C21.8179 10.4554 22.0902 10.1508 22.6884 10.0746C22.9836 10.0365 23.8043 10.0061 24.7323 10.4325L25.0966 8.7458C24.5981 8.56685 23.9538 8.39551 23.1562 8.39551C21.1046 8.39551 19.6628 9.47684 19.6513 11.0265C19.6398 12.1725 20.6828 12.8122 21.4651 13.1929C22.2742 13.5813 22.5465 13.8326 22.5427 14.1829C22.5388 14.7159 21.8984 14.952 21.304 14.9634C20.261 14.9787 19.6551 14.6817 19.1758 14.4608L18.8 16.2047C19.287 16.4255 20.1805 16.6159 21.1046 16.6273C23.2828 16.6273 24.7093 15.5574 24.7169 13.905M16.1272 8.544L12.7679 16.5017H10.5745L8.92171 10.1508C8.82201 9.75859 8.73381 9.61771 8.43087 9.45018C7.93236 9.17985 7.10789 8.92856 6.38696 8.77245L6.43681 8.54019H9.96476C10.4134 8.54019 10.8199 8.83718 10.9196 9.35119L11.7939 13.9583L13.9529 8.54019H16.131L16.1272 8.544Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/VISA.99d42037b110069265d9ff4ebab30bb0.svg";
export { ForwardRef as ReactComponent };